export default{
    items: [],
    services: [],
    countPages: 0,
    current_page: 0,
    page_size: 15,
    totalElements: 0,
    totalPages: 0,
    email: '',
    search_message: '',
    loadingClear: false,
    requestURI: '',
    logsToEdit: {
      channelType: '',
      dateAdded: '',
      list: '',
      message: '',
      messageType: '',
      moeCampaignName: '',
      name: '',
      produtoSlug: null,
      pushType: null,
      requestJson: '',
      responseJson: '',
      sendTime: null,
      smsContent: '',
      title: '',
      url: null
    },
    // teste
    params: ''
  }


// WEBPACK FOOTER //
// ./src/store/modules/push_web/state.js